export default "__VITE_ASSET__C$SQr5iT__"